import BreadCrumb from "../../../components/BreadCrumb";
import { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { toast } from "react-toastify";
import useStyles from "../styles";
import { useUserState } from "../../../context/UserContext";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  Card, CardActionArea, Tooltip,
  Grid, useMediaQuery,
  useTheme
} from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AvailableTemplate from "../../../assets/images/template.svg";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { httprequest } from "../../../data/api";
// import profilemg from "../../../assets/images/profile.png";
import useValidator from "../../../hooks/useValidator";
import Templateimg1 from "../../../assets/images/template1.png";
import Templateimg2 from "../../../assets/images/template2.png";
import Templateimg3 from "../../../assets/images/template3.png";
import Template1 from "../Template/FirstReport";
import Template2 from "../Template/SecondReport";
import Template3 from "../Template/ThirdReport";

const EXTRAS_ENDPOINT = "/api/v1/school-extras";
const PROFILE_ENDPOINT = "/api/v1/profile";

const FirstReport = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(1200));
  const { profile, appLogo, subscription } = useUserState();
  const [selectedId, setSelectedId] = useState(1);
  const [sectionModal, setSectionModal] = useState(false);
  const [titles, setTitles] = useState([{ id: 1, value: "" }]);
  const [sectionName, setSectionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sectionType, setSectionType] = useState("");
  const [extraData, setExtrasData] = useState([]);
  const [sectionValidator, showValidationMessage] = useValidator();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [templateToConfirm, setTemplateToConfirm] = useState(null);
  const subscriptionName = subscription?.pricing_plan?.name;
  const [templateModal, setTemplateModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  useEffect(() => {
    if (profile?.report_template?.template_id) {
      setSelectedId(profile.report_template.template_id);
    }
  }, [profile]);

  const getAllExtras = () => {
    httprequest
      .get(EXTRAS_ENDPOINT)
      .then((res) => {
        setExtrasData(res.data.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const reportData = {
    gender: "Female",
    class: { name: "Grade 5A" },
    session: { session: "2024/2025" },
    admission_date: "2024-09-01",
    class_population: "28",
    admission_no: "GWS/2024/0056",
    student_type: "Day Student",
    total_days: 90,
    days_present: 85,
    days_absent: 5,
    subjects: [
      {
        name: "Mathematics",
        scores: {
          CA_scores: { "CA 1": 18, "CA 2": 17, "CA 3": 19 },
          exam_score: 55,
          total: 89,
          class_highest_score: 95,
          class_lowest_score: 45,
          class_average_score: 78.5,
          grade: "A"
        }
      },
      {
        name: "English Language",
        scores: {
          CA_scores: { "CA 1": 16, "CA 2": 18, "CA 3": 17 },
          exam_score: 52,
          total: 85,
          class_highest_score: 92,
          class_lowest_score: 48,
          class_average_score: 75.2,
          grade: "B"
        }
      },
      {
        name: "Basic Science",
        scores: {
          CA_scores: { "CA 1": 17, "CA 2": 16, "CA 3": 18 },
          exam_score: 50,
          total: 82,
          class_highest_score: 88,
          class_lowest_score: 42,
          class_average_score: 72.8,
          grade: "B"
        }
      },
      {
        name: "Social Studies",
        scores: {
          CA_scores: { "CA 1": 15, "CA 2": 16, "CA 3": 17 },
          exam_score: 48,
          total: 79,
          class_highest_score: 85,
          class_lowest_score: 40,
          class_average_score: 70.1,
          grade: "C"
        }
      },
      {
        name: "Computer Studies",
        scores: {
          CA_scores: { "CA 1": 19, "CA 2": 18, "CA 3": 20 },
          exam_score: 58,
          total: 95,
          class_highest_score: 98,
          class_lowest_score: 50,
          class_average_score: 80.3,
          grade: "A+"
        }
      }
    ],
    extras: [
      {
        section_name: "Extracurricular Activities",
        section_type: "grade",
        section_value: {
          sports: "A",
          music: "B+",
          art: "A-",
          debate: "B"
        }
      },
      {
        section_name: "Social Skills",
        section_type: "score",
        section_value: {
          cooperation: "85%",
          communication: "78%",
          leadership: "90%",
          responsibility: "82%"
        }
      },
      {
        section_name: "Teacher's Comment",
        section_type: "text",
        section_value: "Emily has shown remarkable improvement this term. She is diligent."
      }
    ],
    display_pic: { file_url: null },
    class_teacher_signature: { file_url: null },
    admin_signature: { file_url: null },
    school_stamp: { file_url: null }
  };

  const obtainablescore = [
    {
      ca: [
        { ca_type: "CA 1", score: 20 },
        { ca_type: "CA 2", score: 20 },
        { ca_type: "CA 3", score: 20 }
      ]
    }
  ];

  const attendanceData = {
    total: 10,
    present: 10,
    absent: 30
  };

  const templates = [
    {
      id: "template-1",
      name: "Template 1",
      version: "1.0",
      image: Templateimg1,
      locked: false,
      component: Template1
    },
    {
      id: "template-2",
      name: "Template 2",
      version: "1.0",
      image: Templateimg2,
      locked: !["Pro", "Partner", "Enterprise"].includes(subscriptionName),
      component: Template2
    },
    {
      id: "template-3",
      name: "Template 3",
      version: "1.0",
      image: Templateimg3,
      locked: !["Pro", "Partner", "Enterprise"].includes(subscriptionName),
      component: Template3
    }
  ];

  const handleTemplateModal = () => {
    setTemplateModal(!templateModal);
  };

  const handlePreviewModal = (template = null) => {
    setPreviewTemplate(template);
    setPreviewModal(!previewModal);
    setTemplateModal(false);
  };

  const handleSelect = (template) => {
    if (!template.locked) {
      if (isMobile) {
        handlePreviewModal(template);
      } else {
        setTemplateToConfirm(template);
        setConfirmationModalOpen(true);
      }
    }
  };

  const confirmTemplateSelection = (template = null) => {
    const templateToUse = template || templateToConfirm;

    if (templateToUse) {
      setSelectedId(templateToUse.id);
      setConfirmationModalOpen(false);
      setPreviewModal(false);

      const templateData = {
        report_template: {
          template_id: templateToUse.id,
          version: templateToUse.version
        }
      };

      setIsLoading(true);
      httprequest
        .patch(PROFILE_ENDPOINT, templateData)
        .then((res) => {
          toast.success(res?.data?.message || "Template updated successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          toast.error(err?.response?.message || "Failed to update template");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handlePreviewTemplateSelect = () => {
    if (previewTemplate && !previewTemplate.locked) {
      confirmTemplateSelection(previewTemplate);
    }
  };

  const currentTemplate = templates.find(t => t.id === selectedId)?.component || Template1;
  const comment = "This section can be used as a remark for a student";

  const handleSectionModal = () => {
    setSectionModal(!sectionModal);
  };
  const addTitleField = () => {
    setTitles([...titles, { id: Date.now(), value: "" }]);
  };

  const removeTitleField = (id) => {
    if (titles.length > 1) {
      setTitles(titles.filter(title => title.id !== id));
    }
  };

  const handleTitleChange = (id, value) => {
    setTitles(titles.map(title => title.id === id ? { ...title, value } : title
    ));

    sectionValidator.showMessageFor(`title_${id}`);
  };

  const handleCreateSection = async () => {
    if (sectionValidator.allValid()) {
      setIsLoading(true);

      const payload = {
        report_template: "default",
        extras: [
          {
            section_name: sectionName.toLowerCase(),
            section_type: sectionType.toLowerCase(),
            section_titles: titles.map((t) => t.value.toLowerCase()).filter(Boolean)
          }
        ]
      };

      try {
        const response = await httprequest.post("/api/v1/school-extras", payload);
        toast.success(response.data.message || "Section added successfully!");
        setSectionModal(false); // close modal
        setSectionName("");
        setSectionType("");
        setTitles([{ id: Date.now(), value: "" }]);
      } catch (err) {
        toast.error(err.data.message || "Failed to add section.");
      } finally {
        setIsLoading(false);
      }
    } else {
      showValidationMessage(true); // Show validation errors
    }
  };

  useEffect(() => {
    getAllExtras();
  }, []);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/report/reports"
                link_one_name="Reports"
                active="Manage report template"
                description="manage the details of your report template here"
              />
            </div>
            <div className="flex gap-10">
              {
                isMobile && (
                  <Button
                    variant="primary"
                    buttonSize="fluid"
                    color="btndefault"
                    buttonName="Select Template"
                    buttonIcon={<Icon icon="prime:check-circle" width="24" height="24" />}
                    onClick={handleTemplateModal}
                  />
                )
              }
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Add New Section"
                onClick={handleSectionModal}
              />
            </div>
          </div>
          <Grid container spacing={4}>
            <Grid item lg={8} md={12} sm={12} xs={12}>
              {currentTemplate({
                profile,
                attendanceData,
                reportData,
                obtainablescore,
                comment,
                extraData,
                appLogo
              })}
            </Grid>
            {!isMobile && (
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <div className="right-container relative-full container-border template-right">
                  <div className={classes.container}>
                    <h3 className={classes.title}>Templates</h3>

                    <Grid container spacing={1}>
                      {templates.map((template) => (
                        <Grid item lg={6} md={6} sm={12} xs={12}
                          key={template?.id}
                        >
                          <div className={classes.mycards}>
                            <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                              <Card
                                className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                                  template.locked ? classes.lockedCard : ""
                                }`}
                                onClick={() => handleSelect(template)}
                              >
                                <CardActionArea disabled={template.locked}>
                                  <img src={template?.image} alt={template?.name} className={classes.image} />
                                </CardActionArea>
                              </Card>
                              <p className={classes.templateName}>{template?.name}</p>
                            </Tooltip>
                          </div>
                        </Grid>
                      ))}
                    </Grid>

                    <div className={classes.locknote}>
                      <div>
                        <Icon icon="solar:info-circle-linear" />
                      </div>
                      <p> Access locked templates when you upgrade to a pro account.</p>
                    </div>
                  </div>
                </div>
              </Grid>
            )}

          </Grid>
          <Modal
            title="Add New Section"
            subtitle={<div>Create a new section to be added to the report.</div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Section Name"
                      margin="normal"
                      placeHolder="Name"
                      inputType="text"
                      required
                      inputName="section_name"
                      value={sectionName}
                      onChange={(e) => setSectionName(e.target.value)}

                    />
                    {sectionValidator.message("role", sectionName, "required")}

                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Section Type"
                      required
                      children={
                        <select
                          value={sectionType}
                          onChange={(e) => setSectionType(e.target.value)}
                        >
                          <option value="">--- Select ---</option>
                          <option value="score">Score</option>
                          <option value="grade">Grade</option>
                          <option value="text">Text/Note</option>
                        </select>
                      }
                    />
                    {sectionValidator.message("section_type", sectionType, "required")}

                  </Grid>

                  {sectionType !== "text" && (
                    <>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <p className="label-tag">Title</p>
                        {titles.map((title) => (
                          <>
                            <div key={title.id} className={classes.titlediv}>
                              <input
                                type="text"
                                required
                                placeholder="Name"
                                value={title.value}
                                onChange={(e) => handleTitleChange(title.id, e.target.value)}
                              />
                              <span onClick={() => removeTitleField(title.id)} style={{ cursor: "pointer" }}>
                                <Icon icon="mingcute:delete-2-line" color="red" />
                              </span>
                            </div>
                            {sectionValidator.message("title", title.value, "required|min:2")}
                          </>
                        ))}
                      </Grid>
                      <div onClick={addTitleField}
                        className="flex gap-10 add-another-button"
                      ><Icon icon="gg:add" />  Add Another
                      </div>
                    </>
                  )}
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    onClick={handleCreateSection}
                    isLoading={isLoading}
                    buttonName="Create Section"
                  />
                </div>
              </>
            }
            isopen={sectionModal}
            closeModal={handleSectionModal}
          />
          <Modal
            title="Select Template"
            subtitle="Choose your preferred report template"
            modalContent={
              <div className={classes.templateModalContent}>
                <Grid item lg={4} md={12} sm={12} xs={12}>
                  <div className="right-container relative-full container-border">
                    <div className={classes.container}>
                      <h3 className={classes.templatetitle}>Templates</h3>

                      <Grid container spacing={1}>
                        {templates.map((template) => (
                          <Grid item lg={6} md={6} sm={12} xs={12} key={template?.id}>
                            <div className={classes.mycards}>
                              <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                                <Card
                                  className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                                    template.locked ? classes.lockedCard : ""
                                  }`}
                                  onClick={() => !template.locked && handlePreviewModal(template)}
                                >
                                  <CardActionArea disabled={template.locked}>
                                    <img src={template?.image} alt={template?.name} className={classes.image} />
                                  </CardActionArea>
                                </Card>
                                <p className={classes.templateName}>{template?.name}</p>
                              </Tooltip>
                            </div>
                          </Grid>
                        ))}
                      </Grid>

                      <div className={classes.locknote}>
                        <div>
                          <Icon icon="solar:info-circle-linear" />
                        </div>
                        <p> Access locked templates when you upgrade to a pro account.</p>
                      </div>
                    </div>
                  </div>
                </Grid>
              </div>
            }
            isopen={templateModal}
            closeModal={handleTemplateModal}
          />

          <Modal
            title="Set Default Template"
            subtitle={
              templateToConfirm ? (
                <div>
                        Are you sure you want to set
                  <span className="modal-name-highlight"> {templateToConfirm.name} v{templateToConfirm.version}</span>
                        as your default report template?
                </div>
              ) : null
            }
            modalContent={<></>}
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primaryoutline"
                    buttonSize="full"
                    color="btnfontprimary"
                    buttonName="Cancel"
                    onClick={() => setConfirmationModalOpen(false)}
                  />
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName={isLoading ? "Setting..." : "Set as Default"}
                    onClick={confirmTemplateSelection}
                    disabled={isLoading}
                  />

                </div>
              </>
            }
            isopen={confirmationModalOpen}
            closeModal={() => setConfirmationModalOpen(false)}
          />

          {/* Template Preview Modal */}
          <Modal
            title={previewTemplate ? `Preview - ${previewTemplate.name}` : "Template Preview"}
            subtitle="Preview of the selected template"
            modalContent={
              previewTemplate && (
                <div className={classes.previewContent}>
                  <img
                    src={previewTemplate.image}
                    alt={previewTemplate.name}
                    className={classes.previewTempImage}
                  />
                  <div className={classes.previewInfo}>
                    <h4>{previewTemplate.name}</h4>
                    <p>Version: {previewTemplate.version}</p>
                    {previewTemplate.locked && (
                      <div className={classes.lockedBadge}>
                        <Icon icon="solar:lock-linear" />
                        <span>Pro Feature</span>
                      </div>
                    )}
                  </div>
                </div>
              )
            }
            modalFooter={
              previewTemplate && !previewTemplate.locked && (
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName={isLoading ? "Setting..." : "Select This Template"}
                    onClick={handlePreviewTemplateSelect}
                    disabled={isLoading}
                  />
                </div>
              )
            }
            isopen={previewModal}
            closeModal={handlePreviewModal}
          />

          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default FirstReport;
